import { Attributes, List, LookupBase, Misc, Rules, Utils } from '@singularsystems/neo-core';

export class MinimumShareholdingSummary extends LookupBase {
    static typeName = "MinimumShareholdingSummary";

    constructor() {
        super();
        this.makeObservable();
    }

    public pledgedTrades = new List(PledgedTradesSummary);

    @Attributes.Integer()
    @Attributes.Nullable()
    public sharesHeld: number = 0;

    @Attributes.Nullable()
    @Attributes.Float()
    public sharesHeldInstrumentPrice: number = 0;

    @Attributes.Float()
    public totalMinimumShareholdingRequirementValue: number = 0;

    @Attributes.Float()
    public currentShareholdingValue: number = 0;

    @Attributes.Date()
    public msrDueDate: Date | null = null;

    // Client only properties / methods
    
    @Attributes.Float()
    public get remainingMinimumShareholdingRequirementValue() {
        return this.totalMinimumShareholdingRequirementValue - this.currentShareholdingValue;
    };

    @Attributes.Observable()
    @Attributes.NoTracking()
    public isExpanded: boolean = false;
}

export class PledgedTradesSummary extends LookupBase {
    static typeName = "PledgedTradesSummary";

    constructor() {
        super();
        this.makeObservable();
    }

    public incentiveSchemeName: string = "";

    @Attributes.Float()
    public quantity: number = 0;

    @Attributes.Float()
    public marketPrice: number = 0;

    @Attributes.Nullable()
    @Attributes.Float()
    public value: number | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public tradeDate: Date | null = null;

    // Client only properties / methods
}

export class MinimumShareholdingReportLookup extends LookupBase {
    static typeName = "MinimumShareholdingReportLookup";

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly participantId: string = Utils.emptyGuid();

    @Attributes.Float()
    public readonly annualTCTC: number = 0;

    @Attributes.Nullable()
    @Attributes.Integer()
    public readonly sharesHeld: number | null = null;

    @Attributes.Nullable()
    @Attributes.Float()
    public readonly sharesHeldInstrumentPrice: number | null = null;

    @Attributes.Nullable()
    @Attributes.Float()
    public readonly sharesHeldValue: number | null = null;

    @Attributes.Float()
    public readonly minimumShareholdingRequirementValue: number = 0;

    @Attributes.Float()
    public readonly currentShareholdingValue: number = 0;

    @Attributes.Date()
    public readonly msrDueDate: Date | null = null;

    @Attributes.Nullable()
    @Attributes.Float()
    public readonly msrPercentage: number | null = null;

    // Client only properties / methods
}